module.exports = __webpack_public_path__ + "static/media/ti.e34f5a26.png";